module.exports = __webpack_public_path__ + "static/high-performer-g2-94f24173ba843a750d4e0312c794f802.png";